export default {
  shortContent(content, limit) {
    if (content && (content.length <= limit)) return content;
    const lastWordIndex = content.indexOf(' ', limit + content.indexOf(';">'));
    return content.slice(0, lastWordIndex).concat(' (...)');
  },
};



// WEBPACK FOOTER //
// ./src/utils/filters.js